import dayjs from 'dayjs';
export default {
  name: 'video_sel',
  props: {
    params: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      pageConfig: {
        queryFunName: 'monitorQuery'
      },
      dayjs: dayjs,
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'online_state,lab_id,id',
        labId: this.labId
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      geoMode: {
        Device: '设备',
        Cloud: '云端'
      },
      dicData: {
        typeUpperCode: 'smart_control_type',
        configTypes: [],
        configTypeOptions: {},
        versionUpperCode: 'Device_Protocol',
        configVersions: [],
        configVersionOptions: {}
      }
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    sel: function sel(data) {
      this.$emit('child-monitor-sel', data);
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};